import React from "react";
import { Box, CssBaseline } from "@mui/material";

import Header from "../../../../components/header/Header";
import Topbar from "../../../../components/topbar/TopBar";
import FormBookingLater from "../form/FromBookingLater";
//sidebar
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme as themeStyles } from "@mui/material/styles";
import Sidebar from "../../../../components/sidebar/Sidebar";

const AddBookingLater = () => {
  const themeSidebar = themeStyles();
  const matchesSM = useMediaQuery(themeSidebar.breakpoints.down("sm"));
  return (
    <div>
      <CssBaseline />
      <div className="app">
        {!matchesSM && <Sidebar />}
        <main className="content">
          <Topbar />
          <Box m="5px">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Header title={"RESERVA: Asignar Conductor"} subtitle="" />
            </Box>
            <Box display="grid" gap="10px">
              <Box gridColumn="span 12" gridRow="span 1">
                <FormBookingLater />
              </Box>
            </Box>
          </Box>
        </main>
      </div>
    </div>
  );
};

export default AddBookingLater;
